import { MODULE_DEMANDE_IDENTIFICATION } from "constant/moduleInfo";

export const createDemandeIdentification = async (postData, newData) => {
  const fetchData = await postData(MODULE_DEMANDE_IDENTIFICATION, newData);
  return fetchData;
};
export const updateDemandeIdentification = async (putData, newData) => {
  const fetchData = await putData(MODULE_DEMANDE_IDENTIFICATION, newData);
  return fetchData;
};
